"use client";
import React from "react";
import EmptyConversation from "~/src/secure-chat/Components/EmptyConversation";

const EmptyPage: React.FC = () => {
  return <EmptyConversation />;
};

export default EmptyPage;
